import styled from 'styled-components';

export const AnswerWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;
export const AnswerTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 4px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;

  & > p {
    margin: 0 !important;
  }

  .ant-image {
    width: fit-content;
  }
`;

export const FormulaWrapper = styled.div`
  display: flex;
`;

export const StyledImage = styled.img`
  width: fit-content;
  max-width: 100%;
`;
